export default "__VITE_ASSET__C74FPMyh__"